import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { map, switchMap } from 'rxjs/operators';
import { NavigationService } from 'app/navigation/navigation.service';
import { RuoliOperatoriService } from 'app/main/ruoli-operatori-folder/ruoli-operatori.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(private ruoliOperatoriService: RuoliOperatoriService, private authService: AuthenticationService, private navigationService: NavigationService) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        this.navigationService.setRequestUrl(state.url);
        // console.warn(`setRequestUrl`, state.url);

        return this.authService.authData$.pipe(
            map(authData => {
                //  console.warn(`auth guard for: ${state.url}`);
                //  console.warn(`auth_userRuoli`, this.ruoliOperatoriService.userRuoli);
                
                const isAuthenticated = authData ? true : false;
                
                if (!isAuthenticated) {
                    this.navigationService.navigatoToLogin();
                }
         

                return isAuthenticated;
            })
        );
    }
}
